"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class WindowAPI {
  //-----------------------------------------------
  //-------------------- Constructor --------------
  //-----------------------------------------------
  constructor(_ref) {
    var _ref2;
    let {
      enabled,
      exposeMarketFlows,
      enableDynamicFlow,
      openGuidedSellingModal,
      setFlags,
      setMetadata,
      setSkippedQuestionIds,
      config
    } = _ref;
    //-----------------------------------------------
    //-------------------- Properties ---------------
    //-----------------------------------------------
    this.enableDynamicFlow = void 0;
    this.enabled = void 0;
    this.exposeMarketFlows = void 0;
    this.openGuidedSellingModal = void 0;
    this.setMetadata = void 0;
    this.setFlags = void 0;
    this.setSkippedQuestionIds = void 0;
    this.windowVariable = window;
    this.flows = void 0;
    this.config = void 0;
    this.appName = void 0;
    this.exposeLaunchFunction = () => {
      const launchFunction = params => {
        if (this.enableDynamicFlow) {
          var _params$enable, _params$recommendatio, _params$hideQuestions;
          this.setFlags((_params$enable = params === null || params === void 0 ? void 0 : params.enable) !== null && _params$enable !== void 0 ? _params$enable : []);
          this.setMetadata((_params$recommendatio = params === null || params === void 0 ? void 0 : params.recommendationCategories) !== null && _params$recommendatio !== void 0 ? _params$recommendatio : []);
          this.setSkippedQuestionIds((_params$hideQuestions = params === null || params === void 0 ? void 0 : params.hideQuestionsById) !== null && _params$hideQuestions !== void 0 ? _params$hideQuestions : []);
        }
        this.openGuidedSellingModal();
      };
      this.windowVariable.guidedSelling[this.appName].launchGS = launchFunction;
    };
    this.exposeFlows = () => {
      var _this$flows;
      console.log('exposeFlows', this.flows);
      if (!this.exposeMarketFlows || !((_this$flows = this.flows) !== null && _this$flows !== void 0 && _this$flows.length)) return;
      this.flows.forEach(flowCallback => {
        this.windowVariable.guidedSelling[this.appName][flowCallback({}).name] = input => {
          var _flow$params;
          const flow = flowCallback(input, this.config);
          this.setFlags(flow.params.enable);
          this.setMetadata((_flow$params = flow.params) === null || _flow$params === void 0 ? void 0 : _flow$params.recommendationCategories);
          this.setSkippedQuestionIds(flow.params.hideQuestionsById);
          this.openGuidedSellingModal();
        };
      });
    };
    if (WindowAPI.instance) return WindowAPI.instance;
    // console.log('WindowAPI constructor', enabled, exposeMarketFlows, enableDynamicFlow, config);
    this.enabled = enabled;
    this.exposeMarketFlows = exposeMarketFlows;
    this.enableDynamicFlow = enableDynamicFlow;
    this.openGuidedSellingModal = openGuidedSellingModal;
    this.setFlags = setFlags;
    this.setMetadata = setMetadata;
    this.setSkippedQuestionIds = setSkippedQuestionIds;
    this.config = config;
    this.appName = (_ref2 = config === null || config === void 0 ? void 0 : config.appId) !== null && _ref2 !== void 0 ? _ref2 : 'entryPoint';
    WindowAPI.instance = this;
    this.createWindowObject();
  }
  //-----------------------------------------------
  //-------------------- Methods ------------------
  //-----------------------------------------------
  createWindowObject() {
    if (!this.windowVariable.guidedSelling) {
      this.windowVariable.guidedSelling = {};
    }
    this.windowVariable.guidedSelling[this.appName] = {};
    this.exposeLaunchFunction();
    this.exposeFlows();
  }
}

// Example usage

// guidedSelling.handsetFlowChile.launchGS({
//   recommendationCategories: [{ category: 'handset', filters: { brand: ['Apple'] } }],
//  enable: ['brand-flow-opened-by-window'],
//   hideQuestionsById: ['preferred-device-brand'],
// });
exports.default = WindowAPI;
WindowAPI.instance = void 0;